import _ from 'lodash';

const HELPER_FUNCTION_UTILITY = {
    extractCoveragesByProductKey: (coverages, pKey) => {
        let newCoverages = {};
        _.forEach(_.keysIn(coverages), (memberId) => {
            if (coverages[memberId][pKey]) newCoverages[memberId] = coverages[memberId][pKey];
        });
        return newCoverages;
    },
    getSelectedCoverageOption: (options, id) => {
        return _.find(options, (opt) => opt.id === id);
    },
    getMemberFromFamily: (family, memberId) => {
        if (family.coreMember.id === memberId) return family.coreMember;
        for (let i = 0; i < family.dependents.length; i++) {
            const dep = family.dependents[i];
            if (dep.id === memberId) return dep;
        }
        return null;
    },
    calculateTotalSpent: (coverages, leaveBarterConfig) => {
        const eKeys = _.keysIn(coverages);
        const totalCoverages = _.reduce(eKeys, (acc, eKey, index) => {
            const cKeys = _.keysIn(coverages[eKey]);
            _.forEach(cKeys, (cKey) => {
                const p = coverages[eKey][cKey];
                const o = _.find(p.options, (opt) => opt.id === p.selectOption.id);
                if (o) {
                    acc += o.price;
                }
            });
            return acc;
        }, 0);
        if (leaveBarterConfig && leaveBarterConfig.choice && leaveBarterConfig.enableDeduction) {
            return totalCoverages - leaveBarterConfig.choice.price;
        }
        return totalCoverages;
    },
    parseBalance(_amt) {
        if (!_amt) _amt = 0;
        return parseFloat(parseFloat(_amt).toFixed(2)); 
    },
    numberWithCommas(x, decimals = 2) {
        if (isNaN(x) === true) x = 0;
        x = parseFloat(x).toFixed(decimals);
        x  = x.split(".");
        x[0] = x[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (decimals <= 0) {
            x = x[0];
        } else {
            x = x.join('.');
        }
        return x;
    },
};

export default HELPER_FUNCTION_UTILITY;
